import { useState } from 'react'

import { Collapse, Text, Tooltip } from '@mantine/core'
import { ChevronDown, ChevronRight, FileText } from 'lucide-react'

import { Link, routes } from '@redwoodjs/router'

const DocumentSection = ({ tracker }) => {
  const doc = tracker.document
  const attachments = doc ? [doc] : []
  const [isExpanded, setIsExpanded] = useState(attachments.length > 0)

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <button
          className="flex items-center gap-1 text-doubleNickel-gray-500 hover:text-doubleNickel-gray-700"
          onClick={() => setIsExpanded((v) => !v)}
        >
          {isExpanded ? (
            <ChevronDown size={12} />
          ) : (
            <ChevronRight size={12} />
          )}
          <Text size="xs" fw={400} className="text-inherit">
            DOCUMENTS
            <span className="ml-1 text-doubleNickel-gray-400">
              ({attachments.length})
            </span>
          </Text>
        </button>
      </div>

      <Collapse in={isExpanded}>
        {attachments.length > 0 ? (
          <div className="flex flex-col gap-1">
            {attachments.map((attachment) => (
              <Tooltip
                label={attachment.fileName}
                key={attachment.documentId}
                position="top"
                openDelay={300}
              >
                <Link
                  to={routes.applicantDetails({
                    id: tracker.applicant?.applicantId,
                    tab: 'documents',
                    documentId: attachment.documentId,
                  })}
                  className="flex w-full items-center gap-2 rounded px-2 py-1.5 text-left text-xs text-doubleNickel-gray-700 no-underline hover:bg-doubleNickel-gray-50"
                >
                  <FileText
                    size={14}
                    strokeWidth={1.5}
                    className="flex-shrink-0 text-doubleNickel-gray-400"
                  />
                  <span className="min-w-0 truncate">
                    {attachment.fileName}
                  </span>
                </Link>
              </Tooltip>
            ))}
          </div>
        ) : (
          <Text
            size="xs"
            className="py-1 text-center text-doubleNickel-gray-400"
          >
            No documents
          </Text>
        )}
      </Collapse>
    </div>
  )
}

export default DocumentSection
